import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { issueNavigatorGlobalJiraRoute } from '@jira/router-routes__issue-navigator-routes/src/issueNavigatorGlobalJiraRoute.tsx';
import { GlobalIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/global-app.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getCommonGlobalNavigation } from './common/getCommonGlobalNavigation.tsx';
import { getCommonGlobalResources } from './common/getCommonGlobalResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import {
	globalIssueNavigatorPageEntryPoint,
	globalIssueNavigatorPageEntryPointWithoutPreviewPanel,
} from './ui/index.tsx';

/**
 * Global Issue Navigator Route Entry
 * Handles the new `/jira/issues` route scheme
 */
export const issueNavigatorGlobalJiraRouteEntry: Route = createEntry(
	issueNavigatorGlobalJiraRoute,
	() => ({
		group: 'issue-navigator',
		apdexIgnoreParams: ['issueKey'],
		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},
		skeleton: GlobalIssueNavigatorSkeleton,
		ufoName: 'global-issue-navigator-jfe',
		navigation: getCommonGlobalNavigation(),
		resources: [...getCommonGlobalResources()],
		layout: globalLayout,
		entryPoint: () => {
			return fg('nin_glance_panel_technical_changes')
				? globalIssueNavigatorPageEntryPoint
				: globalIssueNavigatorPageEntryPointWithoutPreviewPanel;
		},
		supportsPreviewPanel: true,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		excludeFromWrmDeferredLoading: true,
		isStreamingEnabled: fg('jfp-magma-ssr-streaming-enable-nin'),
	}),
);
